import { ManagerAuthorization } from '@common/enums';
import { hasOneAuthorization } from '@frontend/utils';
import { PersonalSettingsPreferenceListConsumerContainer } from './PersonalSettingsPreferenceListConsumerContainer';

export function PersonalSettingsPreferenceListConsumerContainerOrganizationWrapper() {
    const isReadOnly = !hasOneAuthorization(ManagerAuthorization.organizationAddEdit);

    return <PersonalSettingsPreferenceListConsumerContainer isReadOnly={isReadOnly} />;
}
